import { A11yModule } from '@angular/cdk/a11y'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { SharingRecordingsFeatureModule, TrmRepositoriesAndUploadsFeatureModule } from '@ftr/data-court-system'
import { CheckboxComponent, FormInputAutofocusDirective, FormInputComponent, UntypedFormComponent } from '@ftr/forms'
import {
  AnchorComponent,
  AnimatedRemoteComponent,
  ButtonComponent,
  ElevioTriggerDirective,
  ErrorRetryComponent,
  IconComponent,
  LineLoaderComponent,
  LoaderComponent,
  ModalComponent,
  NotificationModule,
  PageComponent,
} from '@ftr/foundation'
import { MfaChallengeComponent } from '../challenge'
import { MfaRecoverAccountComponent } from '../recover-account'
import { RecoveryCodeModalComponent } from '../recovery-code-modal'
import { RecoveryCodeModalContentComponent } from '../recovery-modal-content'
import { MfaRequirementComponent, MfaRequirementFormComponent } from '../requirement'
import { MfaSetupRequiredComponent } from '../setup-required'

@NgModule({
  declarations: [
    RecoveryCodeModalComponent,
    RecoveryCodeModalContentComponent,
    MfaRecoverAccountComponent,
    MfaChallengeComponent,
    MfaSetupRequiredComponent,
    MfaRequirementFormComponent,
    MfaRequirementComponent,
  ],
  imports: [
    CommonModule,
    ModalComponent,
    A11yModule,
    NotificationModule,
    ButtonComponent,
    IconComponent,
    AnchorComponent,
    RouterModule,
    ElevioTriggerDirective,
    ModalComponent,
    PageComponent,
    LineLoaderComponent,
    LoaderComponent,
    SharingRecordingsFeatureModule,
    TrmRepositoriesAndUploadsFeatureModule,
    CheckboxComponent,
    AnimatedRemoteComponent,
    ErrorRetryComponent,
    UntypedFormComponent,
    FormInputComponent,
    FormInputAutofocusDirective,
  ],
  exports: [
    RecoveryCodeModalComponent,
    MfaRecoverAccountComponent,
    MfaChallengeComponent,
    MfaRequirementFormComponent,
    MfaRequirementComponent,
    MfaSetupRequiredComponent,
  ],
})
export class MultiFactorAuthenticationModule {}
